<template>
	<v-container fluid class="fullpage">
		<v-layout column >

			<v-toolbar dark height="80" color="black">
				<v-flex xs3><v-toolbar-title class="headline" >Room Photos</v-toolbar-title></v-flex>
				<v-layout align-items-start>
				
				<!-- PAGINATION CONTROL -->	
				<v-flex shrink>
					<v-card v-if="filteredPhotos.length" class="my-1 pr-3 ml-2 mr-2" >
				  		<v-btn small icon>
				  			<v-icon @click="decrementPagination" >
				  				keyboard_arrow_left
				  			</v-icon>
				  		</v-btn>
				  		{{this.currentIndexOfPhotos + 1}} - {{this.endIndex}} 
				  		<v-btn small icon>
				  			<v-icon @click="incrementPagination" >
				  				keyboard_arrow_right
				  			</v-icon>
				  		</v-btn>
				  		<span v-if="filteredPhotos.length">of {{filteredPhotos.length}}</span>
			  		</v-card>
				</v-flex>

				<!-- PAGE LENGTH ADUSTER -->
				
					<v-tooltip bottom v-if="paginatedPhotos.length > 0">
						<v-speed-dial slot="activator"		
							fab 
							v-model="fab"
							direction="right"
							transition="scale-transition">
							<template v-slot:activator>
								<v-btn small icon fab>
									<v-icon medium dark v-if="fab">layers</v-icon>
									<v-icon medium dark v-else>layers</v-icon>
								</v-btn>
							</template>
							<v-btn dark small fab @click="numberOfItemsToShow=12">12</v-btn>	
							<v-btn dark small fab @click="numberOfItemsToShow=24">24</v-btn>
				  			<v-btn dark small fab @click="numberOfItemsToShow=48">48</v-btn>
				  			<v-btn dark small fab @click="numberOfItemsToShow=72">72</v-btn> 
				  			<v-btn dark small fab @click="numberOfItemsToShow=100">100</v-btn> 
						</v-speed-dial>
						<span>Photos per Page</span>
					</v-tooltip>
				

				<v-spacer></v-spacer>
				<v-flex grow></v-flex>	
				<v-flex class="text-xs-right">
					<v-btn v-if="paginatedPhotos.length > 0" @click="checkAll">
						
						{{selectedPhotos.length == 0 ? 'Select ' + selectAmount : 'Unselect All'}}
					</v-btn>
				</v-flex>
			</v-layout>
			  		   
			    <v-btn icon @click="setShowPhotoReview(false)">
		          <v-icon large class="grey--text text--darken-2">close</v-icon>
		        </v-btn>
  			</v-toolbar>

  			<v-layout row >
  				<v-flex xs3>
  					<div class="photoviewport" style="overflow: auto; background-color:#202020;">
  						<v-layout column class="pt-2 px-4">
  							<v-subheader dark class="pl-0">FILTERS</v-subheader>
							<v-flex class="mb-4">
								<EmployeeAutocomplete
									:dark="true"
									:label="employeeSearchLabel"
									:changeHandler="filterByEmployee"									
									:flat="false"				                
					                :singleline="true" v-on:return-employee="filterByEmployee"/> 
				            </v-flex>
							<v-flex class="mb-4" >
								<AutocompleteBuilding
									:label="bldgSearchLabel"
									:dark="true" 
									:changeHandler="filterByBuilding"
									:flat="false"/> 
				            </v-flex>
							<v-flex class="mb-4" >
								<v-autocomplete dark
									autocomplete	
									autofocus	
									label="Tags"
									:items=tags
									@change="filterByTag"
									clearable
									light
									hide-no-data
									hide-details									
									solo
									return-object>
								</v-autocomplete>
							</v-flex>
							<v-flex class="mb-4" >
								<v-autocomplete dark
									autocomplete	
									autofocus	
									label="Special"
									:items="specialItems"
									@change="filterBySpecial"
									clearable
									light
									hide-no-data
									hide-details									
									solo
									return-object>
								</v-autocomplete>
							</v-flex>
							<v-flex v-if="isSuperUser">
								<v-autocomplete dark
									autocomplete	
									autofocus	
									label="Approval Status"
									:items="approvedItems"
									@change="filterByApproval"
									clearable
									light
									hide-no-data
									hide-details									
									solo
									return-object>
								</v-autocomplete>
							</v-flex>
							<v-subheader dark class="pl-0 mt-5">SORT</v-subheader>
							<v-flex>
								<v-autocomplete dark
									autocomplete	
									autofocus	
									label="Default"
									:items="sortItems"
									item-text="label"									
									@change="sortPhotos"
									clearable
									light
									hide-no-data
									hide-details									
									solo
									>
								</v-autocomplete>
							</v-flex>
							<v-layout column v-if="selectedPhotos.length">
								<v-subheader  dark class="pl-0 mt-5">{{selectedPhotos.length}} SELECTED PHOTOS</v-subheader>
								<v-btn v-if="isSuperUser" @click="approveDialog = true">Approve</v-btn>
								<v-btn @click="deleteDialog = true">Delete</v-btn>
								<v-btn @click="clearTagsDialog = true">Clear Tags</v-btn>
							</v-layout>
  						</v-layout>
  					</div>
  				</v-flex>
		  		<v-flex>
		  			<div ref="photoviewport" class="photoviewport" style="overflow: auto; background-color:#202020;">
		  			 

		  			

					<v-layout column v-if="!paginatedPhotos.length && !loading" justify-center class="headline mt-5">
						<v-flex v-if="!isSuperUser" style="color: white;" class="text-xs-center">Use Filters</v-flex>
						<v-flex v-else style="color: white;" class="text-xs-center">No Photos</v-flex>
					</v-layout>

					<v-container grid-list-md fluid>
						<v-progress-linear class="mt-0" v-if="loading" color="blue" indeterminate></v-progress-linear>
					  	<v-layout row wrap>
							<v-flex
							  v-for="(photo, index) in paginatedPhotos"
							  :key="index"
							  :width={}
							  xs12 lg3 xl3>
								  <v-card flat tile>
									
									<v-img contain lazy-src :src=photo.url  >

										<!-- PENDING OVERLAY -->
										<v-layout v-if="!photo.reviewed" class="pa-0 ma-0" align-center
											style="background-color: #FFFFFF;  opacity: 0.5; width:100%; height: 100%;" >
											<v-flex class="text-xs-center headline">Pending</v-flex>
										</v-layout>

										<!-- SELECTION BOX -->
										<div v-if="showElevatedControls(photo)" style="position: absolute; left: 8px; top: 8px; background-color: #FFFFFF;  opacity: 0.5; width:40px; height: 40px;" >
											<v-checkbox :readonly="!showElevatedControls(photo)" style="position: absolute; left: 8px; top: -12px;" v-model="photo.selected" >
											</v-checkbox>
										</div>

										<!-- PANO INDICATOR -->
										<div style="position: absolute; top: 8px; left: 60px; width: 40px; height: 40px;" >			
											<v-layout justify-center class="mt-2">
												<v-icon v-if="isPano(photo)" class="pb-4" color="red darken-2">360</v-icon>
											</v-layout>									
										</div>

										<!-- BOTTOM BAR -->
										<v-layout style="position: absolute; bottom: 0px; background-color: #FFFFFF77;  width: 100%; height: 40px;" class="ma-0">					
											<v-layout class="ml-3 font-weight-bold" align-center>
												<!-- OWNER DISPLAY AND ICON -->
												<v-flex v-show="!editOwnerDialog[index]" @click="showElevatedControls(photo) && showEditOwner(index, photo)" style="cursor: pointer; max-width: 150px;">{{photo.name}}</v-flex>
												<v-card v-if="editOwnerDialog[index]"  elevation="5"
													style="position:absolute; top: -30px; background-color: white; opacity: 0.9; padding-left:0px; padding-right: 0px;"
												>
														<EmployeeAutocomplete
														:dark="true"
														label="Select Employee"
														:singleline="true" v-on:return-employee="setOwner"
													/>

													<v-icon small 
														style="margin-left:5px;"
														@click="editOwnerDialog=[]">close
													</v-icon>

													<v-icon small @click="savePhotos(photo)"
														style="position: relative ; left: 10px;">save</v-icon>
												</v-card>
												
												
												<!-- TAG DISPLAY AND ICON -->
												<v-flex v-show="!editTagsDialogs[index]" style="color: #333333; cursor: pointer; min-width:65px;" class="text-xs-center" 
													@click="showElevatedControls(photo) && showEditTagsDialogs(index, photo)">
													<v-icon v-if="!photo.tags && showElevatedControls(photo)">add</v-icon>
													<span v-if="photo.tags">{{photo.tags}}</span>
												</v-flex>
												
												<!-- TAGS POPUP -->
												<v-card column v-if="editTagsDialogs[index]" elevation="5"
												style="position:absolute; top: -150px; background-color: white; opacity: 0.9; padding-left:10px; padding-right: 10px;">
													<v-layout>
														<v-flex>
															<v-radio-group v-model="radioGroup">
														      <v-radio label="View of Front" value="Front"></v-radio>
														      <v-radio label="View of Back" value="Back"></v-radio>
														      <v-radio label="Layout" value="Layout"></v-radio>
															  <v-radio label="Sign" value="Sign"></v-radio>
															  <v-radio label="Clear Tags" value="clear"></v-radio>
														    </v-radio-group> 
														</v-flex>
														
														<v-icon small 
															style="position: relative; top: -84px;" 
															@click="editTagsDialogs=[]">close</v-icon>
													</v-layout>
													<v-layout justify-end>
														<v-icon small @click="savePhotos(photo)"
														style="position: relative ;  bottom: 32px; right: 0px;">save</v-icon>
													</v-layout>
												</v-card>

												<v-flex class="text-xs-right mr-4">{{photo.roomKey}}</v-flex>
											</v-layout>								
										</v-layout>
																			
										<!-- DELETE PHOTO ICON UPPER RIGHT -->
										<v-dialog width="500" v-model="delDialog[index]" v-if="showElevatedControls(photo)">
										<template v-slot:activator="{ on }">
											<div style="position: absolute; right: 8px; top: 15px;   opacity: 0.5; width:25px;" >
											<v-icon style="text-align: center;" 
													v-on="on"
													color="black"
													@click="delDialog[index]=true">
													delete
											</v-icon>
										</div>

										</template>
										
											<v-card class="pl-2 pt-1 pr-2">
										        <v-card-title class="headline">Confirm Delete</v-card-title>
										        <v-divider></v-divider>
										        <v-card-text class="pt-4 body-2">Delete Photo?</v-card-text>
										        <v-card-actions>
										          	<v-spacer></v-spacer>
										          	<v-btn color="green darken-1" flat @click.native="delDialog=[]">No</v-btn>
										          	<v-btn color="green darken-1" flat 
										          		@click.native="delPhoto(photo)">Yes
										      	 	 </v-btn>
										        </v-card-actions>
									      	</v-card>
								    	</v-dialog>
									</v-img>
								  </v-card>
							</v-flex>
					  	</v-layout>			  	
					</v-container>	  		
				</div>
				</v-flex>	
			</v-layout>	
		</v-layout>

		<v-dialog width="500" v-model="approveDialog">
			<v-card class="pl-2 pt-1 pr-2">
			        <v-card-title class="headline">APPROVE PHOTOS</v-card-title>
			        <v-divider></v-divider>
			        <v-card-text class="pt-4 body-2">
			        	Approve the {{selectedPhotos.length}} Selected Photos?</v-card-text>
			        <v-card-actions>
			          	<v-spacer></v-spacer>
			          	<v-btn color="green darken-1" flat @click.native="approveDialog=false">No</v-btn>
			          	<v-btn color="green darken-1" flat 
			          		@click.native="approveSelected">Yes
			      	 	 </v-btn>
			        </v-card-actions>
		      	</v-card>
		</v-dialog>

		<v-dialog width="500" v-model="clearTagsDialog">
			<v-card class="pl-2 pt-1 pr-2">
			        <v-card-title class="headline">CLEAR TAGS</v-card-title>
			        <v-divider></v-divider>
			        <v-card-text class="pt-4 body-2">
			        	Clear Tags for {{selectedPhotos.length}} Selected Photos?</v-card-text>
			        <v-card-actions>
			          	<v-spacer></v-spacer>
			          	<v-btn color="green darken-1" flat @click.native="clearTagsDialog=false">No</v-btn>
			          	<v-btn color="green darken-1" flat 
			          		@click.native="clearTagsSelected">Yes
			      	 	 </v-btn>
			        </v-card-actions>
		      	</v-card>
		</v-dialog>

		<v-dialog width="500" v-model="deleteDialog">
			<v-card class="pl-2 pt-1 pr-2">
			        <v-card-title class="headline">DELETE PHOTOS</v-card-title>
			        <v-divider></v-divider>
			        <v-card-text class="pt-4 body-2">
			        	Delete {{selectedPhotos.length}} Selected Photos?</v-card-text>
			        <v-card-actions>
			          	<v-spacer></v-spacer>
			          	<v-btn color="green darken-1" flat @click.native="deleteDialog=false">No</v-btn>
			          	<v-btn color="green darken-1" flat 
			          		@click.native="deleteSelected">Yes
			      	 	 </v-btn>
			        </v-card-actions>
		      	</v-card>
		</v-dialog>

	</v-container>
</template>

<script>
import Vuex from 'vuex'
import Vue from 'vue'
import { mapState, mapMutations, mapGetters, mapActions } from 'vuex'
import jscookie from 'js-cookie'
import AutocompleteBuilding from '@/components/forms/AutocompleteBuilding.vue'
import EmployeeAutocomplete from '@/components/forms/EmployeeAutocomplete.vue'

export default {
name: 'PhotoReview',
data () {
	return {
		employeeSearchLabel: "Photographer (Name, NetID)",
		bldgSearchLabel: "Building (Name, Number)",
		dialog: [],
		ctsRooms: [],
		delDialog: [],
		loading: false,
		showAll: false,
		numberOfItemsToShow: 100,  //18
		fab: false,
		currentIndexOfPhotos: 0,
		editTagsDialogs: [],
		radioGroup: null,
		filterNullTags: false,
		tags: ['Front', 'Back', 'Layout', 'Sign'],
		approvedItems: ['Approved', 'Pending'],
		specialItems: ['Classrooms'],
		filters:  [ 
						{ property: 'bldgAlpha', 	value: null },
						{ property: 'netid', 		value: null },
						{ property: 'reviewed', 	value: null },
						{ property: 'tags', 		value: null },
						{ property: 'ClassroomsOnly', 		value: null },
						{ property: 'employeeID',	value: null},
			 		],
		sortItems:  [ 'Building + Room', 'Photographer'],
		approveDialog: false,
		deleteDialog: false,
		clearTagsDialog: false,
		editOwnerDialog: [],
		employeeID: null,
		currentPhoto: null
	}
},

components: { AutocompleteBuilding, EmployeeAutocomplete},

computed: {
	...mapState({   	buildings: state => state.space.buildings,
						fullRoom: state => state.space.fullRoom,
						photos: state => state.space.photos,
						isSuperUser: state => state.user.isSuperUser,
						netid: state => state.user.userProfile.netid,
						userProfile: state => state.user.userProfile,
				}),
	...mapGetters([   'hasRole']),

	selectAmount () {
		return this.numberOfItemsToShow > this.endIndex ? this.endIndex : this.numberOfItemsToShow
	},

	selectedPhotos () {
		return this.paginatedPhotos.filter((photo) => photo.selected ) 
	},

	paginatedPhotos () {
      	return this.filteredPhotos.slice(this.currentIndexOfPhotos, this.endIndex) // Slice does NOT include the end index item
    },

	filteredPhotos () {
		let returnitems = this.photos
		
		let filtered = false // If there is no filter set, non super users see nothing.
		
		// Successive Filtering for each filterterm
    	this.filters.forEach((filter) => {
	    	if (filter.value != null) {
	    		
	    		if (filter.property == "tags") {
	    			returnitems = returnitems.filter((item) => item[`${filter.property}`] && item[`${filter.property}`].includes(filter.value) )
	    			filtered = true
	    		}

	    		if (filter.property == "ClassroomsOnly") {
	    			returnitems = returnitems.filter((item) => this.ctsRooms.includes(item.roomKey) )
	    			filtered = true
	    		}

	    		// Or Use filter property value to filter by
	    		// Need to skip this property or it'll fail
	    		if (filter.property != "ClassroomsOnly")  { returnitems = returnitems.filter((item) => item[`${filter.property}`] == filter.value ) 
	    		filtered = true }

	    	}
	    })
	    return (filtered && returnitems) || (this.isSuperUser && returnitems) || []  // This makes filters required for non super
	    //return returnitems || []
	    
	},	

    endIndex () {
    	let end = this.currentIndexOfPhotos + this.numberOfItemsToShow
    	return end + 1 > this.filteredPhotos.length ? this.filteredPhotos.length : end 
    },
},

created: async function () {	
	console.log(this.netid)
	
	// Filter photos to self.  Default behavior for non super.
	// Disabled.  This causes issues since it doesn't reflect in the Filter Control
	if (!this.isSuperUser) { 
		//this.addFilter('netid', this.netid)
	}	

	// Refresh Badge
	this.isSuperUser && this.fetchUnapprovedPhotos().then((data) => { 
		this.setShowIndicatorPhotoReview(data.length)
	}) 

	// Fetch photos into this.photos
	await this.refreshPhotos()

	// Initial Sort (Unapproved First)	
	this.photos.sort((a,b) => (a.reviewed - b.reviewed) )

	// Grab CTSRooms so that can filter using this list of roomKeys from CTS rooms endpoint
	let rooms = await this.fetchCtsRooms()
	rooms.forEach((room) => { this.ctsRooms.push(room.roomKey) })
},



methods : {
	...mapMutations	([ 	'setShowPhotoReview', 'setShowIndicatorPhotoReview', 'setPhotos', 'setSnackText',				]),
	...mapActions	([ 	'deletePhoto', 	'updatePhotos', 'deletePhotos', 'fetchAllRoomPhotos', 'fetchUnapprovedPhotos', 'fetchCtsRooms']),


	filterByBuilding (building) {
		if (building) 	{ this.addFilter("bldgAlpha", building.bldgAlpha) }
			else 		{ this.addFilter("bldgAlpha", null) }		
	},

	filterByEmployee (employee) {
		if (employee) 	{ this.addFilter("employeeID", employee.employeeID) }
			else 		{ this.addFilter("employeeID", null) }
	},

	filterByTag (tags) {
		if (tags) 		{ this.addFilter("tags", tags) }
			else 		{ this.addFilter("tags", null) }
	},

	filterByApproval (value) {
		if 		(value == 'Approved') 	{ this.addFilter("reviewed", true) }
		else if (value == 'Pending') 	{ this.addFilter("reviewed", false) }
		else 							{ this.addFilter("reviewed", null) }
	},

	filterBySpecial (value) {
		if (value == 'Classrooms')	{ 
				if (!this.ctsRooms.length) { this.setSnackText("Loading a lot of photos.  Just a sec. ") }
				this.addFilter("ClassroomsOnly", true) }
		else  { this.addFilter("ClassroomsOnly", null) }
	},

	addFilter: function (property, value) {
		let myFilter = this.filters.find(filter => filter.property==property)
		myFilter.value = value  	  // This will cause reaction in calculated property filteredPhotos
		this.currentIndexOfPhotos = 0 // Reset Pagination
	},

	sortPhotos(sortProperty) {
		if 		(sortProperty == 'Building + Room') { this.photos.sort((a, b) => (a.roomKey > b.roomKey) ? 1 : -1) }
		else if (sortProperty == 'Photographer') { this.photos.sort((a, b) => (a.netid > b.netid) ? 1 : -1) }
		else this.refreshPhotos()
		this.currentIndexOfPhotos = 0 // Reset Pagination
	},

	isPano: function (photo) {
        	return photo.url.includes('_360Pano') ? true : false
    },

    isClassRoomPhoto: function (photo) { // Centrally Scheduled Classroom
    	if (this.ctsRooms.includes(photo.roomKey)) { return true }
    },

	showElevatedControls(photo) {
		if (this.isOwner(photo))														{ return true }
		//if (this.hasRole("CTS") && this.isClassRoomPhoto(photo)) 		{ return true }	// Redundant.  Being deprecated 8/30/21
		if (this.hasRole("Photos - Classroom") && this.isClassRoomPhoto(photo)) 		{ return true }
		if (this.hasRole("Photos - Sign Shop") && photo.tags && photo.tags.includes("Sign")) 	{ return true }
	},

	delPhoto: function(photo) {
		console.log("Delete Photo")
		this.deletePhoto(photo.key).then(() => { this.refreshPhotos() })
		this.delDialog=[]
		this.dialog=[]
	},

	 async savePhotos (photo) {
			this.editTagsDialogs = []
			this.editOwnerDialog = []
			if (this.radioGroup) {
				photo.tags = []				
				if (this.radioGroup == "clear") { 
					photo.tags = null 
				} else {
					photo.tags.push(this.radioGroup)
				}
			}
			this.radioGroup = null
			let payload=[]
			if(this.employeeID != null) {
				photo.employeeID = this.employeeID
			}
			payload.push(photo)
			console.log("Update Photo")
			await this.updatePhotos(payload)  // takes an array
			this.currentPhoto = null
			this.employeeID = null
	},

	isOwner: function (photo) {		
		let empID = this.userProfile.employeeID
		if (this.isSuperUser || photo.employeeID == empID) { return true}
	},

	refreshPhotos: async function () {
		this.loading=true
		let photos = await this.fetchAllRoomPhotos({})		

		// Add pseudo properties
		photos.forEach((photo) => {
			photo.bldgAlpha = photo.roomKey.split("+")[0]
			photo.selected = false
		})

		this.setPhotos(photos)

		this.currentIndexOfPhotos = 0 // Reset Pagination
		this.loading=false
	},

	incrementPagination: function () {
		if (this.currentIndexOfPhotos + this.numberOfItemsToShow > this.filteredPhotos.length) { return }
		this.currentIndexOfPhotos += this.numberOfItemsToShow
		this.$nextTick(() => { this.$refs.photoviewport.scrollTop = 0 })

	},

	decrementPagination: function () {
		this.currentIndexOfPhotos -= this.numberOfItemsToShow
		if (this.currentIndexOfPhotos < 0) { this.currentIndexOfPhotos = 0}
		this.$nextTick(() => { this.$refs.photoviewport.scrollTop = 0 })
	},

	showEditTagsDialogs (index, photo) {
		Vue.set(this.editTagsDialogs, index, true)
	},


// Not currently part of the data structure
/*	togglePano: function(photo) {
		console.log("Toggle Pano")
		photo.pano = !photo.pano
		//updatePhotos({key: photo.key, pano: photo.pano})
	},*/

	

	checkAll: function() {
		console.log("Toggle Select All")
		if (this.selectedPhotos.length) {
			this.paginatedPhotos.forEach((photo) => { 
				photo.selected = false
			} )
		} else {
			this.paginatedPhotos.forEach((photo) => { 
				photo.selected = true
			} )
		}
	},

	async approveSelected () {
		this.loading = true

		// A new array like this must be used, or else filtering will react
		let photosPayload = []
		this.selectedPhotos.forEach((item) => {
			let photo = {}
			photo.key = item.key
			photo.reviewed = true
			photosPayload.push(photo)
		})

		await this.updatePhotos(photosPayload)
		let data = await this.fetchUnapprovedPhotos()
		this.setShowIndicatorPhotoReview(data.length)
		await this.refreshPhotos()
		this.approveDialog = false
	},

	async deleteSelected () {
		this.loading = true
		await this.deletePhotos(this.selectedPhotos)
		await this.refreshPhotos()
		this.deleteDialog = false
	},

	async clearTagsSelected () {
		this.loading = true

		// A new array like this must be used, or else filtering will react
		let photosPayload = []
		this.selectedPhotos.forEach((item) => {
			let photo = {}
			photo.key = item.key
			photo.tags = null
			photosPayload.push(photo)
		})

		await this.updatePhotos(photosPayload)
		let data = await this.fetchUnapprovedPhotos()
		this.setShowIndicatorPhotoReview(data.length)
		await this.refreshPhotos()
		this.clearTagsDialog = false
	},
	
	showEditOwner (index, photo) 
	{
		this.editOwnerDialog = []
		Vue.set(this.editOwnerDialog, index, true)
		this.currentPhoto = photo
	},

	async setOwner(employee){
		this.employeeID = employee.employeeID
		await this.savePhotos(this.currentPhoto)
		this.refreshPhotos()
	}

},
}

</script>

<style>

.fullpage {
display: absolute;
flex-direction: column;
flex: 1;
z-index: 10;
position: fixed;
top: 0px;
width: 100vw;
background-color: rgba(255, 255, 255, 1);
padding: 0px !important;
margin-top: 0px;
height: 100%;
overflow: hidden;
}

.photoviewport {
	height: calc(100vh - 80px) !important ;
}

</style>



// WEBPACK FOOTER //
// src/components/PhotoReview.vue